import React from 'react';
import axios from 'axios';
import Iframe from 'react-iframe'
import { Auth } from 'aws-amplify';
import { I18n, JS } from '@aws-amplify/core';

import {authConfig} from '../../configures/awsConfig.js'
import {SESSION_INIT_URL, ENERGYMNTR_URL, TERM_VER} from '../../configures/val.js'
import checkTermsVer from '../util/checkTermsVer.js';
import LapDialog from '../util/laplaceDialog.js';
import QueryStrUtil from '../util/queryStrUtil.js';

import {
  SignIn,
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  InputRow,
  ButtonRow,
  Link,
  FederatedButtons,

} from 'aws-amplify-react';

import LogoArea from './logoarea.js';

const myQueryStrUtil = new QueryStrUtil();
export default class MySignUp extends SignIn {
  constructor(props) {
    super(props);

    this.checkContact = this.checkContact.bind(this);
    this.signIn = this.signIn.bind(this);
    this._validAuthStates = ['signIn', 'signedOut', 'signedUp'];
    this.state = {
      idError: '',
      pwError: '',
      termVerError: false
    };
    this.userDataForCheckTerm = {};
  }
  async checkUser() {
    const that = this;
    let user;
    try {
      user = await Auth.currentAuthenticatedUser();
      if (!that._isMounted) { return; }
    } catch(err) {
      if (!that._isMounted) { return; }
      console.log('checkUser ERROR');
      console.log(err);
      return;
    }
    const datum = {
      user
    };
    this.makeSession(datum);
  }
  componentDidMount() {
    this._isMounted = true;
    this.checkUser();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  resetError = () => {
    this.setState({
      idError: '',
      pwError: ''
    });
  }
  checkIsNeedPersonalData = (attr) => {
    for(let i=0; i<attr.length; i++) {
      if((attr[i].Name === 'custom:account_state') && (attr[i].Value === 'temporary')) {
        return true;
      }
    }
    return false;
  }
  moveGrandArch = (user) => {
    const clientId = authConfig.userPoolWebClientId;
    const refreshToken = user.signInUserSession.refreshToken.token;
    // state は GrandARCH 側の csrf 検証に使っています
    window.location.href = myQueryStrUtil.getParamContent('callback')+'?client_id='+clientId+'&refresh_token='+refreshToken+'&state='+myQueryStrUtil.getParamContent('state');
    return;
  }
  movePpms = (user) => {
    const clientId = authConfig.userPoolWebClientId;
    const refreshToken = user.signInUserSession.refreshToken.token;
    // state は PPMS 側の csrf 検証に使っています
    window.location.href = myQueryStrUtil.getParamContent('callback')+'?client_id='+clientId+'&refresh_token='+refreshToken+'&state='+myQueryStrUtil.getParamContent('state');
    return;
  }
  async makeSession(datum, attributes, userData) {
    const {user} = datum;
    // 同意した利用規約のバージョン番号を確認する
    if (!attributes) {
      try {
        attributes = await Auth.userAttributes(user);
      } catch (err) {
        console.log('makeSession: err');
        console.log(err);
        return;
      }
    }
    const isLowVer = checkTermsVer(attributes, 'custom:agreed_term', TERM_VER, 'ver');
    if (isLowVer) {
      if (!userData) {
        return;
      }
      await Auth.signOut();
      this.userDataForCheckTerm = userData;
      this.setState({
        termVerError: true
      });
      return;
    }
    // app=grandarch のときは GrandARCH へ遷移する
    if (myQueryStrUtil.getParamContent('app').includes('grandarch')) {
      this.moveGrandArch(user);
      return;
    }
    // app=ppms のときは PPMS へ遷移する
    if (myQueryStrUtil.getParamContent('app').includes('ppms')) {
      this.movePpms(user);
      return;
    }
    const config = {
      headers: {
        'Content-Type': 'plain/text',
      },
      withCredentials: true,
    };
    // ARCH のセッションを作る
    const urlStr = SESSION_INIT_URL+'client_id='+authConfig.userPoolWebClientId+'&refresh_token='+user.signInUserSession.refreshToken.token;
    try {
      await axios.get(urlStr, config);
    } catch (err) {
      console.log('makeSession ERROR');
      console.log(err);
      this.changeState('signedIn', user);
      this.resetError();
    }
    this.changeState('signedIn', user);
    this.setState({
      archlogout: true
    });
    this.resetError();
    return;
  }
  async checkContact(user, userData) {
    if (!Auth || typeof Auth.verifiedContact !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }
    let data;
    let result;
    try {
      // data = {unverified: {}, verified{email: '<既にメールチェックができているアドレス>'}}
      data = await Auth.verifiedContact(user);
      result = await Auth.userAttributes(user);
    } catch (err) {
      console.log('checkContact: err');
      console.log(err);
      return;
    }
    let datum = {
      user,
      userData
    };
    if (!JS.isEmpty(data.verified)) {
      // 個人情報入力が完了しているかを確認する
      if (this.checkIsNeedPersonalData(result)) {
        await Auth.signOut();
        this.changeState('secondSignUp', datum);
        this.resetError();
        return;
      }
      this.makeSession(datum, result, userData);
    } else {
      const tmpUserObj = Object.assign(user, data);
      datum.user = tmpUserObj;
      await Auth.signOut();
      this.changeState('verifyContact', datum);
      this.resetError();
    }
  }
  getErrorMessage = (err) => {
    const {code, message} = err;
    if (message)
      return message;
    if (code)
      return code;
    if (typeof err === 'string')
      return err;
    return '';
  }
  handleSignInError = (userData, mes) => {
    if (mes === 'User is not confirmed.') {
      this.changeState('confirmSignUp', userData);
      this.resetError();
      return;
    }
    let idError, pwError = '';
    if (mes === '') {
      this.setState({
        idError,pwError
      });
      return;
    }
    if(
      mes === 'Username cannot be empty' ||
      mes === 'User does not exist.'
    ) {
      idError = I18n.get(mes);
    }
    if(
      mes === 'Incorrect username or password.' ||
      mes === 'null failed with error Generate callenges lambda cannot be called..'
    ) {
      if (mes === 'null failed with error Generate callenges lambda cannot be called..') {
        mes = 'Enter your password'
      }
      pwError = I18n.get(mes);
    }
    if (idError !== '' ||pwError !== '') {
      this.setState({
        idError,pwError
      });
      return;
    }
  }
  isError = () => {
    const idErrStr = I18n.get('Enter your ID');
    if (!this.inputs.hasOwnProperty('username')) {
      this.setState({
        idError: idErrStr
      });
      return true;
    }
    if (!this.inputs.hasOwnProperty('password')) {
      const pwErrStr = I18n.get('Enter your password');
      this.setState({
        pwError: pwErrStr
      });
      return true;
    }
    return false;
  }
  checkError = (e) => {
    e.preventDefault();
    if (this.isError())
      return;
    const { username, password } = this.inputs;
    this.signIn(username, password);
  }
  async signIn(username, password) {
    if (!Auth || typeof Auth.signIn !== 'function') {
        throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }
    const userData = {
      username: username,
      pw: password
    };
    try {
      const user = await Auth.signIn(username, password);
      if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
        // MFAが有効になっているときだけ
        this.changeState('confirmSignIn', user);
      } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        // 管理者から招待されたときのフロー
        this.changeState('requireNewPassword', user);
      } else if (user.challengeName === 'MFA_SETUP') {
        this.changeState('TOTPSetup', user);
      } else {
        this.checkContact(user, userData);
      }
    } catch(err) {
      console.log('err');
      const str = this.getErrorMessage(err);
      this.handleSignInError(userData, str);
    }
  }
  archLogout = () => {
    if (this.state.archlogout !== true) return; 
    const logoutUrl = ENERGYMNTR_URL + 'login/logout.php';
    return(
      <Iframe url={logoutUrl} width='0px' height='0px' />
    );
  }
  toForgot = () => {
    this.changeState('forgotPassword');
    this.resetError();
  }
  async closeTermVerError (that) {
    that.changeState('reagreeTermsDocs', this.userDataForCheckTerm);
    this.setState({
      termVerError: false
    });
    return;
  }

  showComponent(theme) {
    const { authState, federated, onStateChange } = this.props;
    return (
      <div className='loginContainer'>
        <LogoArea theme={theme}/>
        <FormSection theme={theme}>
          <SectionHeader theme={theme}>{I18n.get('Sign In')}</SectionHeader>
          <form name='loginForm' onSubmit={this.checkError}>
            <SectionBody theme={theme}>
            <label className='loginLabel'>{I18n.get('Mail')}</label>
            <InputRow
              autoFocus
              placeholder={I18n.get('Username')}
              theme={theme}
              key='username'
              name='username'
              onChange={this.handleInputChange}
            />
            <p className='errorText'>{this.state.idError}</p>
            <label className='loginLabel'>{I18n.get('Password')}</label>
            <InputRow
              placeholder={I18n.get('Password')}
              theme={theme}
              key='password'
              type='password'
              name='password'
              onChange={this.handleInputChange}
            />
            <p className='errorText'>{this.state.pwError}</p>
            <div className='textRight'>
              <Link style={theme.loginForgetpass} theme={theme} onClick={this.toForgot}>
                {I18n.get('I Forgot Password')}
              </Link>
            </div>
            <ButtonRow style={theme.loginLargeButton} theme={theme} type='submit'>
              {I18n.get('Sign In')}
            </ButtonRow>
            <FederatedButtons
              federated={federated}
              theme={theme}
              authState={authState}
              onStateChange={onStateChange}
            />
            </SectionBody>
          </form>
          <SectionFooter theme={theme}>
          <div className='loginSiginFooter' >
            <Link theme={theme} onClick={() => this.changeState('signUp')}>
              {I18n.get('Sign Up')}
            </Link>
          </div>
          </SectionFooter>
        </FormSection>
        {this.archLogout()}
        <LapDialog
          title={''}
          contentElem={
            <div>
              <p>{I18n.get('Terms of Service is updated.')}</p>
              <p>{I18n.get('Please reconfirm it.')}</p>
            </div>
          }
          firstButtonText={'OK'}
          firstButtonFunc={() => this.closeTermVerError(this)}
          open={this.state.termVerError}
          toClose={() => {return;}}
        />
      </div>
    )
  }
}
